import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import Footer from '../../components/Footer';

interface LocationState {
  artistName: string;
  email: string;
}

const SignupSuccess: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const state = location.state as LocationState;

  React.useEffect(() => {
    if (!state || !state.artistName) {
      navigate('/');
    }
  }, [state, navigate]);

  return (
    <div className="min-h-screen flex flex-col pb-16 bg-background">
      <div className="max-w-2xl mx-auto py-12 px-4 flex-1 flex items-center">
        <div className="bg-white rounded-2xl shadow-lg p-8 border border-secondary/20 w-full">
          <div className="text-center">
            {/* Success Icon */}
            <div className="mx-auto w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mb-6">
              <svg
                className="w-8 h-8 text-green-600"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M5 13l4 4L19 7"
                />
              </svg>
            </div>

            <h1 className="text-3xl font-semibold text-primary mb-2">Welcome to ArtistDesk!</h1>
            <p className="text-lg text-secondary mb-6">Your account has been created successfully</p>

            {state && (
              <div className="bg-background rounded-lg p-6 mb-6 text-left space-y-3">
                <div className="flex justify-between">
                  <span className="text-secondary font-medium">Artist Name:</span>
                  <span className="text-secondary">{state.artistName}</span>
                </div>
                <div className="flex justify-between">
                  <span className="text-secondary font-medium">Email:</span>
                  <span className="text-secondary">{state.email}</span>
                </div>
              </div>
            )}

            <div className="bg-highlight/30 rounded-lg p-4 mb-6 border border-primary/20">
              <p className="text-sm text-secondary mb-2">
                <strong>📧 Check Your Email!</strong>
              </p>
              <p className="text-sm text-secondary">
                We've sent a welcome email to your inbox with your login credentials and subscription plan details. Please check your email for further information.
              </p>
            </div>

            <div className="bg-blue-50 rounded-lg p-4 mb-6 border border-blue-200">
              <p className="text-sm text-secondary">
                <strong>⏳ Account Activation Pending</strong>
                <br />
                Your account is currently inactive and will be activated by an admin shortly. You'll be notified once your account is ready to use.
              </p>
            </div>

            <div className="space-y-3">
              <button
                onClick={() => navigate('/login')}
                className="w-full btn-primary py-3 text-lg"
              >
                Go to Login
              </button>
              <button
                onClick={() => navigate('/')}
                className="w-full bg-white border-2 border-primary text-primary px-6 py-3 rounded-xl font-medium hover:bg-primary/5 transition"
              >
                Back to Home
              </button>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default SignupSuccess;
